export default __webpack_public_path__ + "static/media/calendar.bb3495bb.svg";